export default __webpack_public_path__ + "static/media/attractions2.a81b5614.png";